import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createElementBlock as _createElementBlock } from "vue"

import { computed, PropType, ref, watchEffect } from 'vue'
import SpinnerLoader from './SpinnerLoader.vue'
import PulseLoader from './PulseLoader.vue'
import DotLoader from './DotLoader.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Loading',
  props: {
  isLoading: {
    type: Boolean,
    default: false,
  },
  type: {
    type: String as PropType<'spinner' | 'dot' | 'pulse'>,
    default: 'spinner',
  },
  size: {
    type: String,
    default: '24',
  },
  backgroundColor: {
    type: String,
    default: 'none',
  },
  // for overlay element
  isOverlay: {
    type: Boolean,
    default: false,
  },
  // for full page
  isFullscreen: {
    type: Boolean,
    default: false,
  },
},
  setup(__props) {

_useCssVars(_ctx => ({
  "165b6a52": (__props.backgroundColor)
}))

const props = __props
const gLoadingRef = ref<HTMLElement>()
const iconLoader = computed(() => {
  switch (props.type) {
    case 'dot':
      return DotLoader
    case 'pulse':
      return PulseLoader

    default:
      return SpinnerLoader
  }
})
watchEffect(() => {
  if (props.isLoading) {
    gLoadingRef.value?.parentElement?.classList.add('g-loading-parent')
  } else {
    gLoadingRef.value?.parentElement?.classList.remove('g-loading-parent')
  }
})

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    ref_key: "gLoadingRef",
    ref: gLoadingRef,
    class: _normalizeClass(["g-loading-container", {
      'g-loading-container--overlay': __props.isOverlay,
      'full-screen': __props.isFullscreen,
    }])
  }, [
    (_openBlock(), _createBlock(_resolveDynamicComponent(iconLoader.value), { size: __props.size }, null, 8, ["size"])),
    _renderSlot(_ctx.$slots, "default")
  ], 2)), [
    [_vShow, __props.isLoading]
  ])
}
}

})